import React from 'react';
import { Account } from '../../components/accountSettingParts/Account';
import { MultiAccount } from '../../components/accountSettingParts/MultiAccount';
import { Notification } from '../../components/accountSettingParts/Notification';
import { Password } from '../../components/accountSettingParts/Password';
import { AutoReplenishment } from '../../components/accountSettingParts/AutoReplenishment';
import { Devices } from '../../components/accountSettingParts/Devices';
import { Documents } from '../../components/accountSettingParts/Documents';
import { AccountSettingRouteNames } from '../../models/Common';

interface accountSettingPages {
  component: JSX.Element;
  routePath: AccountSettingRouteNames;
  isExact?: boolean;
  label: string;
}

export const accountSettingPages: accountSettingPages[] = [
  {
    component: <Account />,
    routePath: AccountSettingRouteNames.AccountPage,
    label: 'accountSettings.account',
    isExact: true,
  },
  {
    component: <MultiAccount />,
    routePath: AccountSettingRouteNames.MultiAccountPage,
    label: 'accountSettings.multiAccount',
  },
  {
    component: <Notification />,
    routePath: AccountSettingRouteNames.NotificationPage,
    label: 'accountSettings.notifications',
  },
  {
    component: <Password />,
    routePath: AccountSettingRouteNames.PasswordPage,
    label: 'accountSettings.password',
  },
  {
    component: <AutoReplenishment />,
    routePath: AccountSettingRouteNames.AutoReplenishmentPage,
    label: 'accountSettings.regularPayment',
  },
  {
    component: <Devices />,
    routePath: AccountSettingRouteNames.DevicesPage,
    label: 'accountSettings.devices',
  },
];

export const accountSettingPagesWithDocuments: accountSettingPages[] = [
  {
    component: <Account />,
    routePath: AccountSettingRouteNames.AccountPage,
    label: 'accountSettings.account',
    isExact: true,
  },
  {
    component: <MultiAccount />,
    routePath: AccountSettingRouteNames.MultiAccountPage,
    label: 'accountSettings.multiAccount',
  },
  {
    component: <Notification />,
    routePath: AccountSettingRouteNames.NotificationPage,
    label: 'accountSettings.notifications',
  },
  {
    component: <Password />,
    routePath: AccountSettingRouteNames.PasswordPage,
    label: 'accountSettings.password',
  },
  {
    component: <AutoReplenishment />,
    routePath: AccountSettingRouteNames.AutoReplenishmentPage,
    label: 'accountSettings.regularPayment',
  },
  {
    component: <Devices />,
    routePath: AccountSettingRouteNames.DevicesPage,
    label: 'accountSettings.devices',
  },
  {
    component: <Documents />,
    routePath: AccountSettingRouteNames.DocumentsPage,
    label: 'accountSettings.documents',
  },
];
